<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3">Country List </h5>
        <b-row class="float-right">
          <b-col class="my-1">
            <b-form-group horizontal label="" class="mb-3">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-btn class="clearBtn" :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table  striped hover
                  show-empty
                  empty-text="There is no country to show"
                  :fields="tableFields"
                  :filter="filter"
                  :items="history"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <template slot="link" slot-scope="data">
                    <i @click="getLicenceDetail(data.item.country)" title="Detail">
                      <v-icon name="info" base-class="icon-width" @click="getLicenceDetail(data.item.country)">
                      </v-icon>
                    </i>
                  </template>
        </b-table>
        <br>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
      <br><br>
      </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';
import _ from 'lodash'

export default {
  name: 'rollOut',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      history: null,
      userSettingsModal: false,
      filter: null,
      moment: moment,
      tableFields: [
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    const userId = this.$route.query.id;
    this.getHistory(userId);
  },
  methods: {
    async getHistory(userId) {
      const historyData  = [];
      const clientId = '3cc10ad0-9c12-11ea-b1b3-a3c431850c62'
      this.history = await API.get(`Accounts/${clientId}/Licence?filter={"order": "issueDate DESC"}`);
      const historyList = this.history
      const countryList = []
      _.forEach(historyList, listData => {
        if(listData.licenceType === 2) {
          countryList.push(listData)
        }
      })
      this.history = _.uniqBy(countryList, 'country')
      this.totalRows = this.history.length;
    },
    async getLicenceDetail(country) {
      this.$router.push(`/admin/licenseDetail?id=${country}`);
    },
    users() {
      this.$router.push('/admin/users');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.Userlink {
  color: #df8031 !important;
  text-decoration: none !important;
  cursor: pointer;
}
.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/rollOut.vue